module.exports = __webpack_public_path__ + "img/VN.7f84f371.svg";